module.exports = __webpack_public_path__ + "static/media/-_leave.f7513219.png";